import React from 'react';
import './Popup.css';

const Popup = ({ message, type, onClose }) => {
  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-card" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={onClose}>&times;</button>
        <div className={`popup-icon ${type}`}>
          {/* Simple icons: You can improve these */}
          {type === 'success' ? '✔': ' '} 
        </div>
        <div className="popup-message">
          {message}
        </div>
        <button className="popup-ok-btn" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default Popup;